import { RichiestaModuloDTOStatoValidazione } from '@framework/api-client';
import { FlexRow } from '@framework/ui';
import Title from 'antd/es/typography/Title';
import React from 'react';
import styled from 'styled-components';
import { SubmissionModuleState } from '../../fsm/SubmissionModuleState';
import { ModuleStateProgressBar } from './ModuleStateProgressBar';

const SubmissionNavTitleWrapper = styled.div`
  padding: 12px 0;
  padding-top: 24px;
  padding-top: 0;
`;

const SubmissionNavTitle = styled(Title)`
  &&& {
    font-size: ${props => props.theme.fontSizeHeading3}px;
    line-height: ${props => props.theme.lineHeightHeading3};
    padding: 12px 0;
    padding-top: 24px;
    padding-top: 0;
    margin: 0;
    padding: 0;
  }
`;

/**
 * ID dell'elemento del titolo del modulo di richiesta.
 */
export const SUBMISSION_TITLE_FOCUS_ID = 'submission-title-focus-id';
/**
 * Funzione per impostare il focus sul titolo del modulo di richiesta.
 * Viene utilizzata quando cambiano i pulsanti. Per Accessibilità.
 */
export const focusOnSubmissionTitle = () => {
  const titleElement = document.getElementById(SUBMISSION_TITLE_FOCUS_ID);
  titleElement?.focus();
};

export interface ISubmissionTitleProps {
  currentTitle?: React.ReactNode;
  moduleState: SubmissionModuleState;
  validationState: RichiestaModuloDTOStatoValidazione | null | undefined;
  hasSignatures: boolean;
  /** Se la richiesta è inviata, non deve essere visualizzato */
  hideProgressBar?: boolean;
}

/**
 * Titolo di un modulo di richiesta. Include anche la barra di stato, se necessario.
 */
export function SubmissionTitle(props: ISubmissionTitleProps) {
  const {
    currentTitle,
    validationState,
    moduleState,
    hasSignatures,
    hideProgressBar,
  } = props;

  return (
    <SubmissionNavTitleWrapper>
      <FlexRow
        right={
          !hideProgressBar && (
            <ModuleStateProgressBar
              currentState={moduleState}
              hasSignatures={hasSignatures}
              isValid={validationState?.valido}
            />
          )
        }
      >
        <SubmissionNavTitle
          level={2}
          id={SUBMISSION_TITLE_FOCUS_ID}
          tabIndex={-1}
        >
          {currentTitle}
        </SubmissionNavTitle>
      </FlexRow>
    </SubmissionNavTitleWrapper>
  );
}
